"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // import { CampaignItem } from "./interfaces/campaigns";

var utils_1 = require("./utils/utils");

var defaults_1 = __importDefault(require("./defaults"));
/**
 * FT2 api wrapper
 * @param {Object} options
 * @param {string} options.token A token for authorize the api
 * @param {string} [options.hosts=defaults] The hosts for the services defaults to: {@link defaultconfig}
 *
 * @category API
 * @example
 * const api = SounditiApi({
 *  host: 'apihost.com',
 *  token: 'accessToken'
 * });
 *
 * const campaigns = await api.listCampaigns();
 */


var SounditiApi = function () {
  function SounditiApi(_a) {
    var token = _a.token,
        _b = _a.hosts,
        hosts = _b === void 0 ? defaults_1.default : _b;
    this._token = token;
    this.hosts = hosts;
  }

  Object.defineProperty(SounditiApi.prototype, "token", {
    get: function get() {
      return this._token;
    },
    set: function set(value) {
      this._token = value;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Returns a list of Items containing the campaign information
   *
   * @returns {Promise<CampaignItem[]>} a list of campaigns items
   */

  SounditiApi.prototype.listCampaigns = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaigns";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Returns a list of Items modifiad after updatedAt containing the campaign information
   *
   * @param {number} updatedAt When the campaign was updated
   *
   * @returns {Promise<CampaignItem[]>} a list of campaigns items
   */

  SounditiApi.prototype.listCampaignsSinceUpdateAt = function (updatedAt) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaigns?updatedAt=" + updatedAt;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Returns a user owned CampaignItem
   *
   * @param {string} campaignId  The campaign idetifier
   *
   * @returns {Promise<CampaignItem>} The campaign item
   */

  SounditiApi.prototype.getCampaign = function (campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaign/" + campaignId;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Creates a campaign owned by the user
   *
   * @param {object} data The fields to be added to the campaign data
   *
   * @returns {Promise<CampaignItem>} The campaign item
   */

  SounditiApi.prototype.createCampaign = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaign";
        method = 'POST';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(__assign({}, data))
        })];
      });
    });
  };

  ;
  /**
   * Updates all fields in a campaign owned by the user
   *
   * @param {string} campaignId The campaign identifier
   * @param {object} data All fields of the campaign
   *
   * @returns {Promise<CampaignItem>} The updated campaign object
   */

  SounditiApi.prototype.updateCampaign = function (campaignId, data, createCampaignDataVersion) {
    if (createCampaignDataVersion === void 0) {
      createCampaignDataVersion = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaign/" + campaignId;
        method = 'PUT';
        body = {
          data: data,
          createCampaignDataVersion: createCampaignDataVersion
        };
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(body)
        })];
      });
    });
  };

  ;
  /**
   * Deletes a campaign owned by the user
   *
   * @param {string} campaignId The campaign identifier
   */

  SounditiApi.prototype.deleteCampaign = function (campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaign/" + campaignId;
        method = 'DELETE';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method
        })];
      });
    });
  };

  ;
  /**
   * List all files uploaded by the user
   *
   * @returns {Promise<Promise<FileQuery>>}
   */

  SounditiApi.prototype.listFiles = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.files_host + "/file/list";
        method = 'GET';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method
        })];
      });
    });
  };
  /**
   * List files starting with the prefix
   * uploaded by the user
   *
   * @param {string} prefix The prefix of the file name
   *
   * @returns {Promise<Promise<FileQuery>>}
   */


  SounditiApi.prototype.listFilesWithPrefix = function (prefix) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.files_host + "/file/list?prefix=" + prefix;
        method = 'GET';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method
        })];
      });
    });
  };
  /**
   * Request a SAS token for file retrieval
   *
   * @param {string} fileName The file name
   *
   * @returns {Promise<SAS>}
   */


  SounditiApi.prototype.getSharedAccessSignature = function (fileName) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.files_host + "/file/" + fileName;
        method = 'GET';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method
        })];
      });
    });
  };
  /**
   * Creates a SAS token for file uploads
   *
   * @param {string} fileName The file name
   *
   * @returns {Promise<BlobUploadCommonResponse>}
   */


  SounditiApi.prototype.puSharedAccessSignature = function (fileName) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.files_host + "/file/" + fileName;
        method = 'PUT';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method
        })];
      });
    });
  };
  /**
   * updates user profile
   * @param {object} data The user data
   *
   * @returns {Promise<UserData>} The user data updated
   */


  SounditiApi.prototype.updateUser = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.auth_host + "/user";
        method = 'PUT';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify({
            data: data
          })
        })];
      });
    });
  };
  /**
   * Deletes user profile
   * @param {object} data The user data
   */


  SounditiApi.prototype.deleteUser = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.auth_host + "/user";
        method = 'DELETE';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(data)
        })];
      });
    });
  };
  /**
   * Get user public data
   * @param {object} data The user data
   *
   * @returns {Promise<UserData>} The user data
   */


  SounditiApi.prototype.getUser = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.auth_host + "/user";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };
  /**
   * Send the validation email again
   *
   * @param {string} email the email of the user
   */


  SounditiApi.prototype.resendValidation = function (email) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.auth_host + "/resendvalidation?email=" + email;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoBearer(endPoint)];
      });
    });
  };
  /**
   * Requests a new password. An email is sent to the user to reset the password.
   *
   * @param {string} email The email of the user
   *
   * @returns {Promise<Response>} The http response
   *
   * @throws {ConnectionError} A communication error
   */


  SounditiApi.prototype.resetPassword = function (email) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.auth_host + "/user/requestpassword?email=" + email;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoBearer(endPoint)];
      });
    });
  };
  /**
   * Updates the user password
   *
   * @param {string} oldPassword The old password
   * @param {string} newPassword The new password
   *
   */


  SounditiApi.prototype.updatePassword = function (oldPassword, newPassword) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.auth_host + "/user/updatePassword";
        method = 'POST';
        body = JSON.stringify({
          oldPassword: oldPassword,
          newPassword: newPassword
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: body
        })];
      });
    });
  };
  /**
   * Toogles a campaign between status: draft|preview
   *
   * @param {string} campaignId The campaign identifier
   */


  SounditiApi.prototype.previewCampaign = function (campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaign/" + campaignId + "/status";
        method = "PATCH";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method
        })];
      });
    });
  };
  /**
   * Sends a campaign to be processed
   *
   * @param {string} campaignId The campaign identifier
   */


  SounditiApi.prototype.sendToProcess = function (campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaign/" + campaignId + "/process";
        method = "PATCH";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method
        })];
      });
    });
  };
  /**
   * Publish a campaign
   *
   * @param {string} campaignId The campaign identifier
   */


  SounditiApi.prototype.publishCampaign = function (campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaign/" + campaignId + "/publish";
        method = "GET";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method
        })];
      });
    });
  };
  /**
   * Publish a campaign with promotional code optional
   *
   * @param {string} campaignId The campaign identifier
   * @param {string} [code=""] Promotional code
   * @param {boolean} [useWallet=false] True if the user wants to use their wallet amount
   */


  SounditiApi.prototype.publishCampaignWithPromotionalCode = function (campaignId, code, useWallet) {
    if (code === void 0) {
      code = "";
    }

    if (useWallet === void 0) {
      useWallet = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaign/" + campaignId + "/publish";
        method = "POST";
        body = JSON.stringify({
          "code": code,
          "useWallet": useWallet
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: body
        })];
      });
    });
  };
  /**
   * Clone a campaign
   *
   * @param {string} campaignId The campaign identifier
   */


  SounditiApi.prototype.cloneCampaign = function (campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/campaign/" + campaignId + "/clone";
        method = "GET";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method
        })];
      });
    });
  };
  /**
   * Get campaign preview
   */


  SounditiApi.prototype.getCampaignPreview = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/preview/campaign?token=" + this._token;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoBearer(endPoint)];
      });
    });
  };
  /**
   * Get file preview
   */


  SounditiApi.prototype.getFilePreview = function (fileName) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.files_host + "/preview/file/" + fileName + "?token=" + this._token;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoBearer(endPoint)];
      });
    });
  };
  /**
   * Initializes a campaign Checkout
   *
   * @param {string} campaignId The campaign identifier
   * @param {string} code Promotional code
   * @param {boolean} useWallet True if the user wants to use their wallet amount
   */


  SounditiApi.prototype.campaignCheckout = function (campaignId, code, useWallet) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/paycampaign";
        method = "POST";
        body = JSON.stringify({
          "campaignId": campaignId,
          "code": code,
          "useWallet": useWallet
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: body
        })];
      });
    });
  };
  /**
   * Apply a promotional code
   *
   * @param {string} campaignId The campaign identifier
   * @param {string} code Promotional code
   */


  SounditiApi.prototype.applyPromotionalCode = function (campaign, code) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/applypromotionalcode";
        method = "POST";
        body = JSON.stringify({
          "code": code,
          "campaign": campaign
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: body
        })];
      });
    });
  };
  /**
   * Recharges wallet amount of an user
   *
   * @param {UserData} user The user data
   * @param {number} amount The amount to recharge
   */


  SounditiApi.prototype.rechargeWallet = function (user, amount) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/rechargewallet";
        method = "POST";
        body = JSON.stringify({
          "user": user,
          "amount": amount
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: body
        })];
      });
    });
  };
  /**
   * Upgrade subscription
   *
   * @param {UserData} user The user data
   * @param {string} subscriptionId The subscription identifier
   * @param {boolean} isYearPaid True if the user will pay the whole year
   */


  SounditiApi.prototype.subscriptionUpgrade = function (user, subscriptionId, isYearPaid) {
    if (isYearPaid === void 0) {
      isYearPaid = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/subscriptionUpgrade";
        method = "POST";
        body = JSON.stringify({
          "user": user,
          "subscriptionId": subscriptionId,
          "isYearPaid": isYearPaid
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: body
        })];
      });
    });
  };
  /**
   * Cancel subscription. The user will have Free subscription
   *
   * @param {UserData} user The user data
   */


  SounditiApi.prototype.subscriptionCancel = function (user) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/subscriptionCancel";
        method = "POST";
        body = JSON.stringify({
          "user": user
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: body
        })];
      });
    });
  };
  /**
   * Check subscription overuse
   *
   * @param {UserItem} user The user data
   * @param {CampaignItem} campaign The campaign data
   */


  SounditiApi.prototype.checkOveruse = function (user, campaign) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/checkOveruse";
        method = "POST";
        body = JSON.stringify({
          "user": user,
          "campaign": campaign
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: body
        })];
      });
    });
  };
  /**
   * Get user charges from the logged user
   */


  SounditiApi.prototype.getUserCharges = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/charges";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };
  /**
   * Get subscription list
   */


  SounditiApi.prototype.getSubscriptionList = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/getSubscriptionList";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };
  /**
   * Get user saved credit cards from the logged user
   */


  SounditiApi.prototype.getUserCards = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/cards";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };
  /**
   * Gets a SetupIntent id to save a user card
   */


  SounditiApi.prototype.postUserCard = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/saveusercard";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Charge the campaign in the user card
   *
   * @param {string} campaignId The campaign identifier
   * @param {string} cardId The card identifier
   */

  SounditiApi.prototype.chargeUserForCampaign = function (campaignId, cardId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/billing/chargeuser";
        method = 'POST';
        body = JSON.stringify({
          campaignId: campaignId,
          cardId: cardId
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: body
        })];
      });
    });
  };

  ;
  /**
   * Get a tester item
   */

  SounditiApi.prototype.getTester = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/tester";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Get the campaign of the tester
   */

  SounditiApi.prototype.getTesterCampaign = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/tester/campaign";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Check for a public campaign existing
   *
   * @param {string} campaignId The campaign identifier
   */

  SounditiApi.prototype.peekTesterCampaign = function (campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/tester/peek?campaign=" + campaignId;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoBearer(endPoint)];
      });
    });
  };

  ;
  /**
   * Check for a public file existing
   *
   * @param {string} userId The user identifier
   * @param {string} fileName The file name
   */

  SounditiApi.prototype.peekPublicFile = function (userId, fileName) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/tester/peekfile?fileName=" + fileName + "&userId=" + userId;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoBearer(endPoint)];
      });
    });
  };

  ;
  /**
   * Get SAS token for campaign file download
   *
   * @param {string} fileName The file name
   */

  SounditiApi.prototype.getTesterFile = function (fileName) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/tester/file/" + fileName + "?token=" + this._token;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoBearer(endPoint)];
      });
    });
  };

  ;
  /**
   * Put SAS token for interaction file upload
   *
   * @param {string} fileName The file name
   */

  SounditiApi.prototype.postSASTesterFile = function (fileName) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/tester/file/" + fileName + "?token=" + this._token;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoBearer(endPoint, {
          method: "PUT"
        })];
      });
    });
  };

  ;
  /**
   * Updates tester profile
   *
   * @param {object} data The tester data
   */

  SounditiApi.prototype.updateTester = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/tester";
        method = 'PUT';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify({
            data: data
          })
        })];
      });
    });
  };

  ;
  /**
   * Deletes tester profile
   */

  SounditiApi.prototype.deleteTester = function () {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/tester";
        method = 'DELETE';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method
        })];
      });
    });
  };
  /**
   *  Post a new action for the logged tester
   *
   * @param {string} type The type of the action
   * @param {string} moduleId The module identifier
   * @param {string} interactionId The interaction identifier
   * @param {string} device The device type: mobile or desktop
   * @param {string} browser The browser used
   * @param {string} sessionId The session identifier
   * @param {string} createdAt The timestamp when the action was created
   */


  SounditiApi.prototype.postAction = function (type, moduleId, interactionId, device, browser, sessionId, createdAt) {
    if (device === void 0) {
      device = null;
    }

    if (browser === void 0) {
      browser = null;
    }

    if (sessionId === void 0) {
      sessionId = null;
    }

    if (createdAt === void 0) {
      createdAt = null;
    }

    return __awaiter(this, void 0, void 0, function () {
      var endPoint, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/tester/action";
        body = JSON.stringify({
          type: type,
          moduleId: moduleId,
          interactionId: interactionId,
          device: device,
          browser: browser,
          sessionId: sessionId,
          createdAt: createdAt
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: "POST",
          body: body
        })];
      });
    });
  };

  ;
  /**
   *  Post a new action for the panel
   *
   * @param {string} type The type of the action
   * @param {string} moduleId The module identifier
   * @param {string} interactionId The interaction identifier
   * @param {string} device The device type: mobile or desktop
   * @param {string} browser The browser used
   * @param {string} sessionId The session identifier
   * @param {string} createdAt The timestamp when the action was created
   */

  SounditiApi.prototype.postPanelAction = function (type, screen, device, browser, sessionId, createdAt) {
    if (device === void 0) {
      device = null;
    }

    if (browser === void 0) {
      browser = null;
    }

    if (sessionId === void 0) {
      sessionId = null;
    }

    if (createdAt === void 0) {
      createdAt = null;
    }

    return __awaiter(this, void 0, void 0, function () {
      var endPoint, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.panel_host + "/panel/action";
        body = JSON.stringify({
          type: type,
          screen: screen,
          device: device,
          browser: browser,
          sessionId: sessionId,
          createdAt: createdAt
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: "POST",
          body: body
        })];
      });
    });
  };

  ;
  /**
   *  Post a new question for the logged tester
   *
   * @param {string} type The type of action
   * @param {string} moduleId The moduleId to which the interaction belongs
   * @param {string} interactionId The interactionId to which the interaction belongs
   * @param {number} q_id The QA id, it should be a number (for example, a TimeStamp)
   * @param {string} question Full text of the question
   * @param {string} answer Full text of the answer
   */

  SounditiApi.prototype.postQuestionAction = function (moduleId, interactionId, q_id, question, answer) {
    return __awaiter(this, void 0, void 0, function () {
      var type, qa, endPoint, body;
      return __generator(this, function (_a) {
        type = "tester_q_" + q_id;
        qa = {
          q: question,
          a: answer
        };
        endPoint = this.hosts.tester_host + "/tester/questionaction";
        body = JSON.stringify({
          type: type,
          moduleId: moduleId,
          interactionId: interactionId,
          qa: qa
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: "POST",
          body: body
        })];
      });
    });
  };

  ;
  /**
   * Post an interaction for the logged tester
   *
   * @param {string} fileName the name of the file to be reference later (should be unique)
   * @param {string} moduleId the moduleId to which the interaction belongs
   * @param {string} interactionId the interactionId to which the interaction belongs
   */

  SounditiApi.prototype.postInteraction = function (fileName, moduleId, interactionId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/tester/interaction";
        body = JSON.stringify({
          fileName: fileName,
          moduleId: moduleId,
          interactionId: interactionId
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: "POST",
          body: body
        })];
      });
    });
  };

  ;
  /**
   * Gets the campaign main summary
   *
   * @param {string} campaignId The campaign identifier
   */

  SounditiApi.prototype.getCampaingAudienceSummary = function (campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/summary/campaign/" + campaignId;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Gets the campaign replies summary
   *
   * @param {string} campaignId Campaign uuid
   * @param {string} year Year of the summary
   * @param {string} month Month of the summary
   */

  SounditiApi.prototype.getCampaignMonthlySummary = function (campaignId, year, month) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/summary/campaign/" + campaignId + "/year/" + year + "/month/" + month;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Gets the campaign replies summary
   *
   * @param {string} campaignId The campaign identifier
   */

  SounditiApi.prototype.getCampaign30daysSummary = function (campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/summary/campaign/" + campaignId + "/thismonth";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Gets the module replies summary
   *
   * @param {string} moduleId The module identifier
   */

  SounditiApi.prototype.getmodule30daysSummary = function (moduleId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/summary/module/" + moduleId + "/thismonth";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Gets the module audience summary
   *
   * @param {string} moduleId The module identifier
   */

  SounditiApi.prototype.getModuleAudienceSummary = function (moduleId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/summary/module/" + moduleId + "/audience";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Gets the module replies summary
   *
   * @param {string} moduleId The module identifier
   */

  SounditiApi.prototype.getModuleRepliesSummary = function (moduleId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/summary/module/" + moduleId + "/replies";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Gets the module emotion summary
   *
   * @param {string} moduleId The module identifier
   * @param {string} interactionId The interaction identifier
   */

  SounditiApi.prototype.getModuleEmotionSummary = function (moduleId, interactionId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/summary/module/" + moduleId + "/interaction/" + interactionId + "/emotions";
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Gets the module with facial recognition tech metrics
   *
   * @param {string} campaignId The campaign identifier
   * @param {string} moduleId The module identifier
   * @param {number} breakpointsNumber The number of breakpoints
   */

  SounditiApi.prototype.getModuleMetricsFR = function (campaignId, moduleId, breakpoints, filmBreakpoints, withLinks) {
    if (withLinks === void 0) {
      withLinks = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/metrics/fr";
        method = 'POST';
        body = {
          withLinks: withLinks,
          campaignId: campaignId,
          moduleId: moduleId,
          breakpoints: breakpoints,
          filmBreakpoints: filmBreakpoints
        };
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(body)
        })];
      });
    });
  };

  ;
  /**
   * Gets the module with choose tech metrics
   *
   * @param {string} moduleId The module identifier
   */

  SounditiApi.prototype.getModuleMetricsChoose = function (campaignId, moduleId, withLinks) {
    if (withLinks === void 0) {
      withLinks = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/metrics/choose/campaign/" + campaignId + "/module/" + moduleId;
        method = 'POST';
        body = {
          withLinks: withLinks
        };
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(body)
        })];
      });
    });
  };

  ;
  /**
   * Gets the test global summary
   *
   * @param {string} campaignId The campaign identifier
   * @todo Delete the old getCampaingAudienceSummary method
   */

  SounditiApi.prototype.getAudienceGlobalSummary = function (campaignId, withLinksGlobalSummary) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/summary/audience/" + campaignId;
        body = JSON.stringify({
          withLinksGlobalSummary: withLinksGlobalSummary
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: "POST",
          body: body
        })];
      });
    });
  };

  ;
  /**
   * Creates a link of a campaign
   *
   * @param {CreateLinkRequest} link The link request object with the campaignId, the alias, and if it is link and/or active
   * @returns {Promise<Link>} The created link object
   *
   */

  SounditiApi.prototype.createLink = function (link, withStatistics) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/createLink";
        method = 'POST';
        body = {
          link: link,
          withStatistics: withStatistics
        };
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(body)
        })];
      });
    });
  };

  ;
  /**
   * Gets all the links of a campaign
   *
   * @param {string} campaignId The campaign identifier
   * @returns {Promise<Link[]>} The links list of a campaign
   */

  SounditiApi.prototype.getLinks = function (campaignId, withStatistics) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/getLinks/" + campaignId;
        body = JSON.stringify({
          withStatistics: withStatistics
        });
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: "POST",
          body: body
        })];
      });
    });
  };

  ;
  /**
   * Updates a link
   *
   * @param {Link} link The link object with the new changes
   * @returns {Promise<Link>} The updated link object
   */

  SounditiApi.prototype.updateLink = function (link, withStatistics) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/updateLink";
        method = 'PUT';
        body = {
          link: link,
          withStatistics: withStatistics
        };
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(body)
        })];
      });
    });
  };

  ;
  /**
   * Gets a link object giving the link url
   *
   * @param {string} linkUrl The link url
   * @returns {Promise<Link>} The updated link object
   */

  SounditiApi.prototype.getLinkByUrl = function (linkUrl) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.tester_host + "/getLinkByUrl/" + linkUrl;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Checks if an url is available
   *
   * @param {string} linkUrl The link url
   * @returns {bollean} True if available false ioc
   */

  SounditiApi.prototype.checkAvailableUrl = function (linkUrl) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/checkAvailableUrl/" + linkUrl;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Deletes a link
   *
   * @param {Link} link The link object with the new changes
   * @returns {Promise<Link>} The deleted link object
   */

  SounditiApi.prototype.deleteLink = function (link) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/deleteLink";
        method = 'DELETE';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(__assign({}, link))
        })];
      });
    });
  };

  ;
  /**
   * Gets statistics of new users created between a date range
   *
   * @param {string} sinceDAte date from which you want to make the query
   * @param {string} untilDate date until which you want to make the query
   * @example
   * format data "2021-06-15"
   * @returns {Promise<Object>} An object with the following information: numDays, endDate, beginDate, newUsers
   */

  SounditiApi.prototype.getUsersCreated = function (sinceDate, untilDate) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.panel_host + "/panel/newusers?sinceDate=" + sinceDate + "&untilDate=" + untilDate;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   * Gets stats of new users and their campaigns between a date range
   *
   * @param {string} sinceDAte date from which you want to make the query
   * @param {string} untilDate date until which you want to make the query
   * @example
   * format data "2021-06-15"
   * @returns {Promise<Object>} An object with the following information: numDays, endDate, beginDate, newUsers, campaignsCreatedByNewUsers, enrolledTestersInCampaignsCreatedByNewUsers
   */

  SounditiApi.prototype.getCampaignsByNewUsers = function (sinceDate, untilDate) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.panel_host + "/panel/newusers/campaigns?sinceDate=" + sinceDate + "&untilDate=" + untilDate;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };

  ;
  /**
   *
   * This function returns the emotional engagement sorted in bins
   *
   * @param {string} campaignId The campaign id
   * @param {string} moduleId The module id
   * @param {string} [stimulusId = ""] The stimulus id. If it is empty, the function will return all the stimuli.
   *
   * @returns An array which each element has the stimulusId, the fileName and the bins information with the number of people and the percentage.
   */

  SounditiApi.prototype.getEmotionalEngagementHistogram = function (campaignId, moduleId, stimulusId) {
    if (stimulusId === void 0) {
      stimulusId = "";
    }

    return __awaiter(this, void 0, void 0, function () {
      var endPoint;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/emotionalEngagementHistogram/campaignId/" + campaignId + "/moduleId/" + moduleId + "?stimulusId=" + stimulusId;
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token)];
      });
    });
  };
  /**
   * Gets all the data versions of a campaign
   *
   * @param {string} campaignId The campaign identifier
   * @param {number} [fromCreatedAt = 0] The timestamp from when the data were created
   * @param {number} [fromCreatedAt = 0] The timestamp from when the data were created
   * @param {number} [fromCreatedAt = 0] The timestamp from when the data were created
   * @returns {Promise<Link[]>} The links list of a campaign
   */


  SounditiApi.prototype.getCampaignVersions = function (campaignId, numberOfPage, offset, fromCreatedAt) {
    if (numberOfPage === void 0) {
      numberOfPage = 1;
    }

    if (offset === void 0) {
      offset = 50;
    }

    if (fromCreatedAt === void 0) {
      fromCreatedAt = 0;
    }

    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/getCampaignVersions";
        method = 'POST';
        body = {
          campaignId: campaignId,
          numberOfPage: numberOfPage,
          offset: offset,
          fromCreatedAt: fromCreatedAt
        };
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(body)
        })];
      });
    });
  };

  ;
  /**
   * Updates a campaign version
   *
   * @param {string} campaignId The campaign identifier
   * @param {number} createdAt The timestamp when the version was created
   * @param {string} name The name of the version
   *
   * @returns {Promise<CampaignVersion>} The updated link object
   */

  SounditiApi.prototype.updateCampaignVersion = function (campaignId, createdAt, name) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/updateCampaignVersion";
        method = 'PUT';
        body = {
          campaignId: campaignId,
          createdAt: createdAt,
          name: name
        };
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(body)
        })];
      });
    });
  };

  ;
  /**
  * Updates a campaign version
  *
  * @param {string} campaignId The campaign identifier
  * @param {number} createdAt The timestamp when the version was created
  * @param {string} name The name of the version
  *
  * @returns {Promise<CampaignVersion>} The updated link object
  */

  SounditiApi.prototype.payAudience = function (payAudienceRequest) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method;
      return __generator(this, function (_a) {
        endPoint = this.hosts.billing_host + "/payAudience";
        method = 'POST';
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(payAudienceRequest)
        })];
      });
    });
  };

  ;
  /**
   * Returns the full campaign metrics
   *
   * @param {string} campaignId Campaign uuid
   * @param {boolean} [idDemo = false] If true return demo metrics for all modules
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<ModuleMetricsChoose>} The module with choose tech metrics
   *
   * @throws {PermissionError} Auth token not valid
   */

  SounditiApi.prototype.campaignMetrics = function (campaignId, isDemo) {
    if (isDemo === void 0) {
      isDemo = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.analysis_host + "/metrics/campaign";
        method = 'POST';
        body = {
          campaignId: campaignId,
          isDemo: isDemo
        };
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(body)
        })];
      });
    });
  };

  ;
  /**
   * Creates testers related with a campaidn
   *
   * @param {string} campaignId The campaign identifier
   * @param {string[]} emails A list with the emails of the testers
   *
   * @returns {Promise<TesterItem[]>} The module with choose tech metrics
   *
   * @throws {PermissionError} Auth token not valid
   */

  SounditiApi.prototype.addTestersToCampaign = function (emails, campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/addTestersToCampaign";
        method = 'PUT';
        body = {
          campaignId: campaignId,
          emails: emails
        };
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(body)
        })];
      });
    });
  };

  ;
  /**
   * Reactivates a tester froma film campaign
   *
   * @param {string} campaignId The campaign identifier
   * @param {string} emails The email of the tester to reactivate
   *
   * @returns {Promise<TesterItem>} The tester item updated
   *
   * @throws {PermissionError} Auth token not valid
   */

  SounditiApi.prototype.reactivateFilmTester = function (email, campaignId) {
    return __awaiter(this, void 0, void 0, function () {
      var endPoint, method, body;
      return __generator(this, function (_a) {
        endPoint = this.hosts.campaign_host + "/reactivateFilmTester";
        method = 'POST';
        body = {
          campaignId: campaignId,
          email: email
        };
        return [2
        /*return*/
        , utils_1.tryApiFetchNoJson(endPoint, this._token, {
          method: method,
          body: JSON.stringify(body)
        })];
      });
    });
  };

  ;
  return SounditiApi;
}();

exports.default = SounditiApi;